import React from 'react';
import ESGManagementHero from '../component/product-page/ESGManagementHero';
import AddScheduleCall from '../component/product-page/AddScheduleCall';
import OurClientAndPartners from '../component/product-page/OurClientAndPartners';
// import Blog from '../home-page/Blog';
import StartYourESGJourney from '../component/product-page/StartYourESGJourney';
import SattvaProductPage from '../component/product-page/SattvaProductPage';
import FAQ from '../component/product-page/FAQs';

const ProductsComponent = () => {
  window.scrollTo(0, 0);

  return (
    <div className="w-full text-[4vw] md:text-[2vw]">
      <ESGManagementHero />
      <AddScheduleCall />
      <OurClientAndPartners />
      <SattvaProductPage />
      <FAQ/>
      <StartYourESGJourney />

      {/* <div className='text-[0.425em] bg-gray-50 dark:bg-[#0F172A]'>
        <Blog text={''} h3Heading={'Academy Blogs from Learning & Insights'} card_bg={'dark:bg-slate-800 border'} />

      </div> */}
    </div>
  )
}

export default ProductsComponent;